/*
 * @Author: cuihaopeng cuihaopeng@slodon.cn
 * @Date: 2023-05-24 15:22:35
 * @LastEditors: cuihaopeng cuihaopeng@slodon.cn
 * @LastEditTime: 2024-10-15 13:40:57
 * @FilePath: /aopumai_pc/src/utils/config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 *  项目的配置文件
 */
export const apiUrl = 'https://www.opmcoinvent.com/';//接口请求地址
export const chatUrl = 'wss://im.opmcoinvent.com';//客服地址
export const mUrl = 'https://m.opmcoinvent.com/'//移动端网页地址
// export const apiUrl = 'https://apmpc.slodon.cn/';//接口请求地址
// export const chatUrl = 'wss://im-b2c.55sld.com';//客服地址
// export const mUrl = 'https://apmmobile.slodon.cn/'//移动端网页地址
export const curLang = 'zh';//当前语言,zh:中文，若为其他语言，需要对应/src/assets/language下面的文件名
export const title = '奥浦迈商城';//浏览器顶部title
export const h5CaptchaAppId='196985009';	//腾讯云的appid-天御
export const gdKey = 'c75752e5fc84dc076afa9fb8bb7c537a';//高德web-js key
export const gdSecurityCode = '88fe51bfe1d483522a8e8349e01a7056'//高德web-js 安全密钥
export const statShowDebug = false;//是否开启统计的调试

// ** copyright *** slodon *** version-v2.5 *** date-2023-03-08 ***主版本v2.5



